<button class="cpp-button cpp-toolbar-button" [u4Popover]="dateFilter">
  <svg><use xlink:href="#Calendar"></use></svg>
  <span>{{ label }}</span>
</button>

<ng-template #dateFilter>
  <form [formGroup]="form">
    <div class="cpp-form-items cpp-form-items--sm">
      <div class="cpp-form-item" [class._has-error]="!form.get('start').valid">
        <label class="cpp-input-label" for="date-filter-start">{{ labels['general.from'] }}</label>
        <input class="cpp-input" id="date-filter-start" type="date" formControlName="start"/>
      </div>
      <div class="cpp-form-item" [class._has-error]="!form.get('end').valid">
        <label class="cpp-input-label" for="date-filter-end">{{ labels['general.to'] }}</label>
        <input class="cpp-input" id="date-filter-end" type="date" formControlName="end"/>
      </div>
    </div>
    <button class="cpp-button cpp-button--sm cpp-button--link"
            *ngIf="active"
            (click)="reset()">
      {{ labels['faceted-search.label.any-date'] }}
    </button>
    <button class="cpp-button cpp-button--sm cpp-button--link"
            *ngFor="let option of options"
            (click)="filterBy(option.days)">
      <span id="{{option.key}}">{{ labels['periods.last-' + option.key] }}</span>
    </button>
  </form>
</ng-template>
